import type { LessonEditStore } from './interfaces'

export const getters = {
  isLoading: (state: LessonEditStore): boolean => state.loading,
  getLesson: (state: LessonEditStore): LessonEditStore['lesson'] => state.lesson,
  getSlots: (state: LessonEditStore): LessonEditStore['slots'] => state.slots,
  getDate: (state: LessonEditStore): LessonEditStore['date'] => state.date,
  getStartTime: (state: LessonEditStore): LessonEditStore['startTime'] => state.startTime,
  getDuration: (state: LessonEditStore): LessonEditStore['duration'] => state.duration,
  /** The lesson start as the API takes it: 'Y-m-d H:i:s', or '' while the date or time is not chosen. */
  getStart: (state: LessonEditStore): string => (state.date && state.startTime ? `${state.date} ${state.startTime}:00` : ''),
  getStatus: (state: LessonEditStore): LessonEditStore['status'] => state.status,
  getReasonCategory: (state: LessonEditStore): LessonEditStore['reasonCategory'] => state.reasonCategory,
  getReason: (state: LessonEditStore): LessonEditStore['reason'] => state.reason,
  getTutorId: (state: LessonEditStore): LessonEditStore['tutorId'] => state.tutorId,
  getFilters: (state: LessonEditStore): LessonEditStore['filters'] => state.filters,
  isTutorModalOpen: (state: LessonEditStore): boolean => state.tutorModalOpen,
  getActionModal: (state: LessonEditStore): LessonEditStore['actionModal'] => state.actionModal,
  isDeleteConfirmOpen: (state: LessonEditStore): boolean => state.deleteConfirmOpen,
  getReassignReason: (state: LessonEditStore): LessonEditStore['reassignReason'] => state.reassignReason,
  getReassignComment: (state: LessonEditStore): LessonEditStore['reassignComment'] => state.reassignComment,
  isSaving: (state: LessonEditStore): boolean => state.saving,
}
